import { AnalyticActivityModel } from './analytic-activity.model';
import { WidgetPlatformEnum } from './widget-platform.enum';

export class DeveloperAnalyticModel {
  platform: WidgetPlatformEnum;

  app_productkey: string;
  app_userid: string;

  app_activity: string;
  // app_activity_status: string;

  app_apikey: string;
  app_domain: string;

  widget_is_fullscreen: boolean;

  app_activity_data: AnalyticActivityModel | any;
}
